import { Language } from '../../../common/languages.js';

export interface IBingoLang {
  clientId: string;
}

export type IBingoLangState = {
  [lang in Language]: IBingoLang;
};

export class BingoLangClass implements IBingoLang {
  clientId: string;

  constructor(bingo?: Partial<IBingoLang>) {
    this.clientId = bingo?.clientId ?? '';
  }
}
